// extracted by mini-css-extract-plugin
module.exports = {"header":"InfoCard_header__W_E4T"};